import { render } from "./detail.vue?vue&type=template&id=a1656586&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=a1656586&lang=less&scoped=scoped"
import "./detail.vue?vue&type=style&index=1&id=a1656586&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1656586"]])

export default __exports__